import * as React from "react";
import type { CSSProperties } from "react";
import { KonturColors } from "@skbkontur/colors";

import { declint } from "../../../Engine/utils";

export const ErrorsCount = (props: { value: number; style?: CSSProperties }) => {
    const plural = declint(props.value, ["ошибка", "ошибки", "ошибок"]);
    return (
        <span style={{ color: KonturColors.mainErrorTextRed90, fontSize: 14, fontWeight: 400, ...props.style }}>
            {props.value}&nbsp;{plural}
        </span>
    );
};
